import React from "react";

import { COMPARE_METRICS } from "consts";

import { DeltaRow } from "pages/admin/soilSight/utils/compareTypes.ts";
import { formatDelta, valueColor } from "pages/admin/soilSight/utils/compareUtils.ts";

export const MultipleVersionSummary = ({ deltas }: { deltas: DeltaRow[] }) => {
  const totals: Record<string, { sum: number; count: number }> = {};
  for (const row of deltas) {
    for (const metric of COMPARE_METRICS) {
      const delta = row.deltas[metric.key];
      if (delta !== null && delta !== undefined) {
        if (!totals[metric.key]) totals[metric.key] = { sum: 0, count: 0 };
        totals[metric.key]!.sum += delta;
        totals[metric.key]!.count += 1;
      }
    }
  }

  return (
    <>
      <div className="soil-sight-summary-hint">
        <strong>Summary</strong> — average delta (B minus A) across all {deltas.length} scenario combinations, averaged over matched years. Green = improvement,
        red = regression.
      </div>
      <div className="soil-sight-summary-cards">
        {COMPARE_METRICS.map((metric) => {
          const metricTotals = totals[metric.key];
          const avgDelta = metricTotals && metricTotals.count > 0 ? metricTotals.sum / metricTotals.count : null;
          const color = valueColor(avgDelta, metric.higherIsBetter);
          return (
            <div key={metric.key} className="soil-sight-summary-card">
              <div className="soil-sight-summary-card-label">{metric.label}</div>
              <div className="soil-sight-summary-card-value" style={{ color }}>
                {formatDelta(avgDelta)}
              </div>
              {metric.unit && <div className="soil-sight-summary-card-unit">{metric.unit}</div>}
            </div>
          );
        })}
      </div>
    </>
  );
};
